import { conPantallaDeError } from './PantallaDeError';
import { createBrowserRouter } from 'react-router-dom';
import { publicRoutes } from './routes.public';
import { crmRoutes } from './routes.crm';
import { notFoundRoute } from './routes.shared';

// Grupos de rutas reutilizados por los entry points del split:
//   apps/imperium-web (público) → publicRoutes  (./routes.public)
//   apps/crm (Booster)          → crmRoutes     (./routes.crm)
export { publicRoutes, crmRoutes, notFoundRoute };

// Router COMBINADO (bundle único actual — backward compat, src/App.tsx).
// Importar este módulo arrastra AMBOS grupos; las apps separadas importan
// directo de routes.public / routes.crm para no mezclar código.
export const router = createBrowserRouter(conPantallaDeError([
  ...publicRoutes,
  ...crmRoutes,
  notFoundRoute,
]));
